// --------------------------------------------------------
// Get discount price based on discount type
// --------------------------------------------------------
export default function getRulePrice(price, rule) {
	
	
	const ruleCalculator = {
		'fixed_amount': ()=> (rule.value),
		'percentage_discount': ()=> (price * (1 - (rule.value) / 100)),
		'amount_discount': ()=> (price - (rule.value)),
		'percentage_of_base': ()=> (price * ((rule.value || 0) / 100))
	}
	
	return ruleCalculator[rule.price_rule]?.() || 0
	
	
}